module.exports = __webpack_public_path__ + "svg/flags/sh-hl.svg";